module.exports = __webpack_public_path__ + "static/media/full-banner.c6a0696d.jpg";